<nb-layout>
  <nb-layout-column>
    <div *ngIf="responsiveMode === 'lg'"
      class="d-flex flex-column align-items-center justify-content-center position-relative">
      <div class="m-auto py-5">
        <img class="img-error-403" src="assets/images/errors/error-403.png" alt="">
        <div class="d-flex flex-column align-items-center justify-content-between text-position mt-5">
          <p class="main-text">ورود به صفحه موردنظر امکان‌پذیر نمی‌باشد.</p>
          <p class="description">شما اجازه دسترسی به صفحه‌ای که می‌خواهید در وبسایت تارت به آن مراجعه کنید را ندارید.</p>
          <div class="button-action">
            <button nbButton (click)="pageBack()">صفحه خانه</button>
          </div>
        </div>
      </div>
    </div>
    <div  *ngIf="responsiveMode === 'md'" class="m-auto">
      <img class="img-error-403" src="assets/images/errors/error-403.png" alt="">
      <div class="d-flex flex-column align-items-center justify-content-between">
        <p class="main-text">ورود به صفحه موردنظر امکان‌پذیر نمی‌باشد.</p>
        <p class="description">شما اجازه دسترسی به صفحه‌ای که می‌خواهید در وبسایت تارت به آن مراجعه کنید را ندارید.</p>
        <div class="button-action">
          <button nbButton (click)="pageBack()">صفحه خانه</button>
        </div>
      </div>
    </div>
  </nb-layout-column>
</nb-layout>
